import { DAP_URLS } from "../../globals";
import { router } from "../router/Router";
import { invokeHTTPRequest } from "./network";

export function disableKeyBoardSave(targetElem, useCapture = false) {
    if (!targetElem) { return; }
    targetElem.addEventListener('keydown', function (evt) {
        evt = evt || window.event;
        if (evt.ctrlKey || evt.metaKey) {
            if (evt.key === 's') { //ctrl + s
                evt.preventDefault();
            }
        }
    }, useCapture);
}

export function addDAPScript(target) {
    if (!target) { return; }
    let dapMode = localStorage.getItem('DAP') || '';
    dapMode = dapMode.toLowerCase();
    if (dapMode === 'off') { return; }
    const script = document.createElement('script');
    script.async = true;
    script.type = 'text/javascript';
    script.src = dapMode === 'dev' ? DAP_URLS.DEV : DAP_URLS.PROD;
    target.appendChild(script);
}

export function fetchApps() {
    return new Promise((resolve, reject) => {
        Promise.allSettled([
            invokeHTTPRequest(`${router.appPrefix}/static/apps.base.json`),
            invokeHTTPRequest(`${router.appPrefix}/static/apps.json`)])
            .then(values => {
                resolve(parseApps(values));
            })
            .catch(err => {
                reject(err);
            });
    });
}
function parseApps(values) {
    const appsMap = new Map();
    values.forEach((res) => {
        if (res.status === 'fulfilled' && Array.isArray(res.value)) {
            res.value.forEach(app => {
                if (!appsMap.has(app.name)) {
                    appsMap.set(app.name, app);
                }
            });
        }
    });
    return Array.from(appsMap.values()).filter(app => !app.hidden || app.accessible);    
}

export function overrideStorageAPI(window, prefix) {
    if (!window || !prefix) return;

    const script = document.createElement('script');
    script.textContent = `
        (function() {
            const localStorageSetItem = localStorage.setItem;
            const localStorageGetItem = localStorage.getItem;
            const localStorageRemoveItem = localStorage.removeItem;
            const sessionStorageSetItem = sessionStorage.setItem;
            const sessionStorageGetItem = sessionStorage.getItem;
            const sessionStorageRemoveItem = sessionStorage.removeItem;
            
            const prefix = "__${prefix}__";

            localStorage.setItem = function(key, value) {
                localStorageSetItem.call(this, prefix + key, value);
            };

            localStorage.getItem = function(key) {
                return localStorageGetItem.call(this, prefix + key);
            };

            localStorage.removeItem = function(key) {
                localStorageRemoveItem.call(this, prefix + key);
            };

            sessionStorage.setItem = function(key, value) {
                sessionStorageSetItem.call(this, prefix + key, value);
            };

            sessionStorage.getItem = function(key) {
                return sessionStorageGetItem.call(this, prefix + key);
            };

            sessionStorage.removeItem = function(key) {
                sessionStorageRemoveItem.call(this, prefix + key);
            };
        })();
    `;
    window.document.head.appendChild(script);
}